export const getPropertyValuesString = (obj, properties) => properties
  .map(property => obj[property])
  .filter(value => Boolean(value))
  .join(' ')
